import { parseEnvUrl } from '@/utils/env';

const apiUrl = import.meta.env.VITE_API_URL ?? 'http://127.0.0.1:8000';
const isDevServer = import.meta.env.MODE === 'development';

const API_ROUTE = isDevServer
  ? window.location.origin
  : parseEnvUrl(apiUrl, window.location.protocol);
const WS_ROUTE = API_ROUTE.replace('https://', 'wss://').replace('http://', 'ws://');

const BASE_URL = `${API_ROUTE}/api/v1/`;
const BASE_IMAGE_URL = API_ROUTE;
const BASE_WS_URL = `${WS_ROUTE}/ws/v1`;

const ADOBE_PUBLISHER_URL = 'https://indd.adobe.com/';

const config = {
  BASE_URL,
  BASE_WS_URL,
  API_TIMEOUT_MILISECONDS: 180000,
  TOAST_DURATION: 2,
  ADOBE_PUBLISHER_URL,
  BASE_IMAGE_URL,
  SPINNER_DELAY_MILISECONDS: 50,
  DEFAULT_QUIZ_TIME_IN_SECONDS: 15,
  NYC3_BASE_URL: `https://nyc3.digitaloceanspaces.com/astro-space-${
    import.meta.env.MODE === 'production' ? 'prod' : 'dev'
  }`,
  ALTERNATIVE_DEFAULT_IMAGE: '/images/course-default-image.png',
};
export default config;
